<div
  ngbDropdown
  class="language-flag-container d-flex h-100"
  *ngIf="availableLanguages"
  placement="bottom-right"
  [class.no-flags]="!(isLanguageFlagIconEnabled$ | async)"
>
  <button class="btn btn-link p-0 my-auto border-0" id="languageFlagDropdown" ngbDropdownToggle>
    <span
      class="flag:{{
        (isCountryFlagInsteadEnabled$ | async)
          ? (activeCountry$ | async | uppercase)
          : (shimanoActiveLanguageCountryIsocode | uppercase)
      }} mr-2"
    ></span>
    {{ shimanoActiveLanguageIsocode | uppercase }}
    <div
      ngbDropdownMenu
      class="dropdown-menu dropdown-menu-right rounded-0 border-0 js-header-language"
      aria-labelledby="languageFlagDropdown"
    >
      <button
        ngbDropdownItem
        class="d-flex align-items-center rounded-0"
        [class.selected]="shimanoActiveLanguageIsocode === item.isocode"
        (click)="setShimanoActiveLanguage(item.isocode)"
        *ngFor="let item of availableLanguages"
        [attr.data-name]="item.name"
        [attr.data-iso]="item.country.isocode"
      >
        <span
          class="flag:{{
            (isCountryFlagInsteadEnabled$ | async) ? (activeCountry$ | async | uppercase) : item.country.isocode
          }} mr-1"
        ></span>
        {{ item.name }}
        <mat-icon
          svgIcon="check"
          class="ml-auto md-12 dark"
          *ngIf="shimanoActiveLanguageIsocode === item.isocode"
        ></mat-icon>
      </button>
    </div>
  </button>
</div>
